//@flow

import type {ProductPricesWrapper} from "./productPricingTypes";
import {getAccountNumber, getUserPostCode, isMaxUser} from "../utils";
import getProductPrices from "./getProductPrices";
import storeProductPrices from "./storeProductPrices";
import {updateDisplayedPrices} from "./updateDisplayedPrices";
import {getLocationPostcode} from "../location-cookie";
import {addUpdateDisplayedPriceEvents} from "./priceEventHandlers";
import {checkDefaultPriceOptionPermission, extractProductTilesToFetchPrices, restoreDataFromBrowser} from "./priceUtils";
import {initCartButtonState, enableProductButtons} from "../add-to-cart";
import initClearancePrices from "../clearance/clearancePrice";

const initPrices = async (win: WindowProxy) => {
  const { showGstInclusivePreference, displayPricesOptionPreference } = restoreDataFromBrowser(win);
  const accountNumber = isMaxUser(win) ? getAccountNumber(win) : undefined;
  const postCode = getUserPostCode(win) || getLocationPostcode();
  const defaultDisplayPricesOption = checkDefaultPriceOptionPermission(win, displayPricesOptionPreference);
  const defaultShowGstInclusive = showGstInclusivePreference !== undefined && showGstInclusivePreference.toString() ? showGstInclusivePreference : true;
  const defaultPack = '1';
  const defaultQuantity = 1;
  const productCodesWithShowPrice : string[] = extractProductTilesToFetchPrices(win).map(el => el.dataset.productCode);

  if (accountNumber || postCode) {
    const allPrices : ProductPricesWrapper[] = await getProductPrices(productCodesWithShowPrice, accountNumber, postCode);
    storeProductPrices(win, allPrices);
    productCodesWithShowPrice.forEach(productCode => updateDisplayedPrices(win, productCode, defaultQuantity, defaultPack, defaultShowGstInclusive, defaultDisplayPricesOption));
    addUpdateDisplayedPriceEvents(win);
  }

  try {
    initCartButtonState(win);
    
    // Enable buttons after cart state is initialized and prices are loaded
    if (accountNumber || postCode) {
      // Wait for web components to be rendered before enabling buttons
      if (win.customElements) {
        win.customElements.whenDefined('add-to-cart').then(() => {
          // Use requestAnimationFrame to ensure components are rendered
          requestAnimationFrame(() => {
            enableProductButtons(win);
          });
        });
      } else {
        enableProductButtons(win);
      }
    }
  } catch (err){
     throw new Error(err);
  }

  initClearancePrices(win);
};

export default initPrices;

